import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { AuthenticationGuard } from 'microsoft-adal-angular6';
import { AuthGuard } from './shared/services/auth/auth.guard';
import { constUrpi } from './shared/helpers/constants';

export const rootRouterConfig: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '', component: AuthLayoutComponent, children: [
      { path: '', loadChildren: './views/login/login.module#LoginModule', data: { title: 'Inicio de sesión' } }, 
      { path: 'sessions', loadChildren: './views/sessions/sessions.module#SessionsModule', data: { title: 'Session'} }
    ] },
  { path: '', component: AdminLayoutComponent, children: [
      { 
        path: 'bienvenida', 
        loadChildren: './views/bienvenida/bienvenida.module#BienvenidaModule', 
        canActivate: [AuthenticationGuard, AuthGuard], 
        data: { 
          title: 'Bienvenido', 
          breadcrumb: 'Bienvenido', 
          module: "" 
        } 
      },
      { 
        path: 'acceso-restringido', 
        loadChildren: './views/acceso-restringido/acceso-restringido.module#AccesoRestringidoModule', 
        canActivate: [], 
        data: { 
          title: 'Acceso Restringido', 
          breadcrumb: 'Acceso Restringido', 
          module: ""
        } 
      },
      { 
        path: 'prospecto', 
        loadChildren: './views/prospecto/prospecto.module#ProspectoModule', 
        canActivate: [AuthenticationGuard, AuthGuard], 
        data: { 
          title: 'Bandeja de prospectos', 
          breadcrumb: 'Prospectos', 
          module: constUrpi.module.prospectoWeb
        } 
      },
      { 
        path: 'administrador', 
        loadChildren: './views/administrador-perfil/administrador-perfil.module#AdministradorPerfilModule', 
        canActivate: [AuthenticationGuard, AuthGuard], 
        data: { 
          title: 'Administración de Equipos y Perfiles', 
          breadcrumb: 'Administración de Equipos y Perfiles', 
          module: constUrpi.module.admPerfilWeb
        } 
      },
      { 
        path: 'reporte-ventana-ganadora', 
        loadChildren: './views/reporte-ventana-ganadora/reporte-ventana-ganadora.module#ReporteVentanaGanadoraModule', 
        canActivate: [AuthenticationGuard, AuthGuard], 
        data: { 
          title: 'Reporte Ventana Ganadora', 
          breadcrumb: 'Reporte Ventana Ganadora', 
          module: ""
        } 
      },
      { 
        path: 'visita', 
        loadChildren: './views/visitas/visitas.module#VisitasModule', 
        canActivate: [AuthenticationGuard, AuthGuard], 
        data: { 
          title: 'Carga de Visitas Post', 
          breadcrumb: 'Carga de Visitas Post', 
          module: constUrpi.module.visitasWeb
        } 
      },
      { 
        path: 'notificacion', 
        loadChildren: './views/notificacion/notificacion.module#NotificacionModule', 
        canActivate: [AuthenticationGuard, AuthGuard], 
        data: { 
          title: 'Notificación', 
          breadcrumb: 'Notificación', 
          module: constUrpi.module.notifWeb
        } 
      },
      { 
        path: 'procesamiento-rol-perfil', 
        loadChildren: './views/procesamiento-rol-perfil/procesamiento-rol-perfil.module#ProcesamientoRolPerfilModule', 
        canActivate: [AuthenticationGuard, AuthGuard], 
        data: { 
          title: 'Procesamiento roles y perfiles', 
          breadcrumb: 'Procesamiento roles y perfiles', 
          module: constUrpi.module.proRropeWeb
        } 
      }
    ]
  },
  { path: '**', redirectTo: 'sessions/404' }
];

